module.exports = __webpack_public_path__ + "static/img/why-6.3872d15a.jpg";